<template>
  <div class="sh_ai_chat_main" :style="{ width: width }">
    <slot name="header">
      <div class="chat_main_head">
        <div class="chat_head_title">{{ aiChatTitle || '新的会话' }}</div>
        <div class="chat_model" v-if="aiModelList.length > 0">
          <el-select :value="activeModelId" @change="onChangeModel">
            <el-option
              v-for="item in aiModelList"
              :key="item[aiModelOptions.valueKey]"
              :label="item[aiModelOptions.labelKey]"
              :value="item[aiModelOptions.valueKey]"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </slot>
    <slot :messageData="item" :index="index">
      <div class="chat_main_body">
        <el-scrollbar ref="scrollbar" style="height: 100%">
          <div v-for="(item, index) in aiMessageList" :key="item.id">
            <div class="user_message_box message_box" v-if="item[aiMessageOptions.roleKey] === aiMessageOptions.userKey">
              <div class="user_message_content message_content">
                {{ item[aiMessageOptions.contentKey] }}
              </div>
              <div class="avatar_box">
                <i class="el-icon-user"></i>
              </div>
            </div>
            <div class="ai_message_box message_box" v-else-if="item[aiMessageOptions.roleKey] === aiMessageOptions.aiKey">
              <div class="avatar_box">
                <i class="iconfont icon-Ai"></i>
              </div>
              <div v-if="loading && index === aiMessageList.length - 1" class="is_loading">
                <i class="el-icon-loading"></i>
              </div>
              <div class="ai_message_content message_content footer_button_hover" v-else>
                <div class="markdown-body" v-html="item[aiMessageOptions.contentKey]"></div>
                <div class="ai_message_box_footer" v-if="index === aiMessageList.length - 1">
                  <el-tooltip effect="dark" content="重新生成" placement="top">
                    <el-button type="text" @click="onMessageRefresh(item)" icon="el-icon-refresh"></el-button>
                  </el-tooltip>
                </div>
                <div class="ai_message_box_footer ai_message_footer_hide" v-else>
                  <el-tooltip effect="dark" content="重新生成" placement="top">
                    <el-button type="text" @click="onMessageRefresh(item)" icon="el-icon-refresh"></el-button>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </slot>
    <slot name="footer">
      <div class="chat_main_footer">
        <div class="chat_footer_input">
          <el-input
            class="no_boder"
            type="textarea"
            :autosize="{
              minRows: 1,
              maxRows: 5
            }"
            placeholder="请输入内容"
            v-model.trim="message"
            ref="messageInput"
          ></el-input>
        </div>
        <div class="chat_footer_btn">
          <el-button type="primary" @click="onSendMessage" :disabled="!message" :loading="loading">发送</el-button>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ShAiChatMain',
  data() {
    return {
      message: ''
    }
  },
  props: {
    width: {
      type: [String, Number],
      default: '80%'
    },
    aiModelList: {
      type: Array,
      default: () => []
    },
    activeModelId: {
      type: [String, Number],
      default: null
    },
    aiChatTitle: {
      type: String,
      default: ''
    },
    aiModelOptions: {
      type: Object,
      default: () => ({
        valueKey: 'id',
        labelKey: 'name'
      })
    },
    aiMessageList: {
      type: Array,
      default: () => []
    },
    aiMessageOptions: {
      type: Object,
      default: () => ({
        contentKey: 'content',
        userKey: 'user',
        aiKey: 'assistant',
        roleKey: 'role'
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChangeModel(val) {
      this.$emit('update:activeModelId', val)
      this.$emit('change-model', val)
    },
    onSendMessage() {
      this.$emit('send', this.message)
      this.message = ''
      this.$nextTick(() => this.scrollToBottom())
      this.focus()
    },
    scrollToBottom() {
      const wrap = this.$refs.scrollbar?.$el.querySelector('.el-scrollbar__wrap')
      if (wrap) {
        wrap.scrollTop = wrap.scrollHeight
      }
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.messageInput?.$el.querySelector('textarea')?.focus()
      })
    },
    onMessageRefresh(e) {
      this.$emit('refresh', e)
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.messageInput?.$el.querySelector('textarea')?.focus()
    })
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
